import i18next, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

export const LANGUAGES: Language[] = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'ja', name: 'Japanese', native: '日本語' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'zh', name: 'Chinese', native: '中文' },
  { code: 'ar', name: 'Arabic', native: 'العربية' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands' },
  { code: 'sv', name: 'Swedish', native: 'Svenska' },
  { code: 'no', name: 'Norwegian', native: 'Norsk' },
  { code: 'da', name: 'Danish', native: 'Dansk' },
  { code: 'fi', name: 'Finnish', native: 'Suomi' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'cs', name: 'Czech', native: 'Čeština' },
  { code: 'ro', name: 'Romanian', native: 'Română' },
  { code: 'hu', name: 'Hungarian', native: 'Magyar' },
  { code: 'el', name: 'Greek', native: 'Ελληνικά' },
  { code: 'bg', name: 'Bulgarian', native: 'Български' },
  { code: 'hr', name: 'Croatian', native: 'Hrvatski' },
  { code: 'sk', name: 'Slovak', native: 'Slovenčina' },
  { code: 'sl', name: 'Slovenian', native: 'Slovenščina' },
  { code: 'lt', name: 'Lithuanian', native: 'Lietuvių' },
  { code: 'lv', name: 'Latvian', native: 'Latviešu' },
  { code: 'mk', name: 'Macedonian', native: 'Македонски' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu' },
  { code: 'mt', name: 'Maltese', native: 'Malti' },
  { code: 'nb', name: 'Norwegian Bokmål', native: 'Norsk Bokmål' },
  { code: 'nn', name: 'Norwegian Nynorsk', native: 'Norsk Nynorsk' },
  { code: 'oc', name: 'Occitan', native: 'Occitan' },
];

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LangResource extends Resource {}
export function initialiseI18next(language = 'en', resources: LangResource) {
  console.log('initialiseI18next', { language, resources });

  return (
    i18next
      // pass the i18n instance to react-i18next.
      .use(initReactI18next)
      //init i18next
      //for all options read: https://www.i18next.com/overview/configuration-options
      .init({
        compatibilityJSON: 'v3',
        lng: language,
        fallbackLng: LANGUAGES.map((lng) => lng.code),
        debug: process.env.NODE_ENV !== 'production',
        resources,
        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        },
      })
  );
}
